module.exports = __webpack_public_path__ + "assets/phone-011.27e4f7108dbabc90ed2dc702d877bd5e.png";


//////////////////
// WEBPACK FOOTER
// ./app/landingPage/assets/img/device/phone-011.png
// module id = 874
// module chunks = 0